export class RegistrationViewModel {
    UserName : string;
    Password : string;
    Email : string;
    FirstName : string;
    LastName : string;
    IdCountry : number;
    IdState: number;
}
